module.exports = __webpack_public_path__ + "img/arianna-natale.1afa6f88.svg";